import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Monitor, ArrowLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { db, ensureDbOpen } from '../db/database';

const NodeSelect = () => {
  const [nodes, setNodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { user, station, selectNode } = useAuth();

  useEffect(() => {
    if (!station) {
      navigate('/stations');
      return;
    }
    loadNodes();
  }, [station, navigate]);

  const loadNodes = async () => {
    try {
      setIsLoading(true);
      await ensureDbOpen();
      // Load nodes only from local DB filtered by current station
      const localNodes = await db.nodes
        .where('spaceId')
        .equals(station.id)
        .toArray();
      const activeNodes = localNodes.filter((n) => n.active === 1 || n.active === true);
      setNodes(activeNodes);
    } catch (error) {
      console.error('Error loading nodes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNodeSelect = (node) => {
    selectNode(node);
    navigate('/products');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900 flex items-center justify-center">
        <div className="text-white text-xl">Cargando nodos...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900 p-4">
      <div className="max-w-2xl mx-auto pt-8">
        <div className="flex items-center mb-8">
          <button
            onClick={() => navigate('/stations')}
            className="p-3 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-colors mr-4"
          >
            <ArrowLeft size={24} />
          </button>
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">
              {station?.name}
            </h1>
            <p className="text-gray-300">Selecciona tu punto de venta</p>
          </div>
        </div>

        <div className="space-y-4">
          {nodes.map((node) => (
            <button
              key={node.id}
              onClick={() => handleNodeSelect(node)}
              className="card w-full p-6 hover:border-primary-500 transition-all flex items-center justify-between group"
            >
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-xl flex items-center justify-center">
                  <Monitor size={28} className="text-white" />
                </div>
                <div className="text-left">
                  <h3 className="text-xl font-semibold text-white">
                    {node.name}
                  </h3>
                  <p className="text-gray-400 text-sm">Punto de venta</p>
                </div>
              </div>
              <ChevronRight 
                size={28} 
                className="text-gray-400 group-hover:text-primary-400 transition-colors" 
              />
            </button>
          ))}
        </div>

        {nodes.length === 0 && (
          <div className="card p-8 text-center">
            <Monitor size={48} className="text-gray-600 mx-auto mb-4" />
            <p className="text-gray-400 mb-2">No hay puntos de venta disponibles</p>
            <p className="text-gray-500 text-sm">Contacta al administrador para configurar nodos</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NodeSelect;
